import { jsx } from "react/jsx-runtime";
import { ButtonBase, styled } from "@mui/material";
import { memo } from "react";
function createIconButtonTrigger(props) {
  const { icon, squared } = props;
  function IconButtonTrigger(triggerProps) {
    return /* @__PURE__ */ jsx(
      BaseButton,
      {
        disabled: triggerProps.disabled,
        onClick: triggerProps.onClick,
        squared,
        sx: triggerProps.sx,
        children: icon
      }
    );
  }
  const memoIconButtonTrigger = memo(IconButtonTrigger);
  return memoIconButtonTrigger;
}
const BaseButton = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== "squared",
  slot: "IconButtonTrigger"
})(({ squared, theme }) => {
  return {
    backgroundColor: theme.palette.action.focus,
    borderRadius: squared ? 0 : "50%",
    height: 48,
    width: 48
  };
});
export {
  BaseButton,
  createIconButtonTrigger
};
//# sourceMappingURL=IconButtonTrigger.js.map
